/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'
import { subscriptionCheckoutDataStatusSchema } from './SubscriptionCheckoutDataStatusSchema'

export const subscriptionCheckoutDataSchema = z.object({
	status: subscriptionCheckoutDataStatusSchema,
	clientSecret: z.string().nullable(),
	publishableKey: z.string().nullable(),
})

export type SubscriptionCheckoutDataSchema = z.infer<typeof subscriptionCheckoutDataSchema>
